import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IspettoratiFormComponent } from './dialogs/form/form.component';
import { IspettoratiComponent } from './ispettorati.component';

const routes: Routes = [
  {
    path: '', component: IspettoratiComponent
  },
  {
    path: 'inserisci', component: IspettoratiFormComponent,
    data: { title: 'Inserimento Ispettorati' },
  },
  {
    path: ':idIspettorato', component: IspettoratiFormComponent,
    data: { title: 'Visualizazzione Ispettorato' },
  },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IspettoratiRoutingModule { }
